export const TRANCHE_ABI = [
  {
    'inputs': [
      {
        'internalType': 'address',
        'name': 'vaultAddress',
        'type': 'address'
      },
      {
        'internalType': 'bool',
        'name': '_directWithdrawEnabled',
        'type': 'bool'
      }
    ],
    'stateMutability': 'nonpayable',
    'type': 'constructor'
  },
  {
    'inputs': [
      {
        'internalType': 'address',
        'name': 'authority',
        'type': 'address'
      }
    ],
    'name': 'AccessManagedInvalidAuthority',
    'type': 'error'
  },
  {
    'inputs': [
      {
        'internalType': 'address',
        'name': 'caller',
        'type': 'address'
      },
      {
        'internalType': 'uint32',
        'name': 'delay',
        'type': 'uint32'
      }
    ],
    'name': 'AccessManagedRequiredDelay',
    'type': 'error'
  },
  {
    'inputs': [
      {
        'internalType': 'address',
        'name': 'caller',
        'type': 'address'
      }
    ],
    'name': 'AccessManagedUnauthorized',
    'type': 'error'
  },
  {
    'inputs': [
      {
        'internalType': 'address',
        'name': 'target',
        'type': 'address'
      }
    ],
    'name': 'AddressEmptyCode',
    'type': 'error'
  },
  {
    'inputs': [
      {
        'internalType': 'enum PauseCategory',
        'name': 'category',
        'type': 'uint8'
      }
    ],
    'name': 'CategoryPaused',
    'type': 'error'
  },
  {
    'inputs': [
      {
        'internalType': 'uint256',
        'name': 'attempted',
        'type': 'uint256'
      },
      {
        'internalType': 'uint256',
        'name': 'limit',
        'type': 'uint256'
      }
    ],
    'name': 'DepositLimitExceeded',
    'type': 'error'
  },
  {
    'inputs': [],
    'name': 'DirectWithdrawModeDisabled',
    'type': 'error'
  },
  {
    'inputs': [],
    'name': 'DirectWithdrawModeEnabled',
    'type': 'error'
  },
  {
    'inputs': [
      {
        'internalType': 'address',
        'name': 'implementation',
        'type': 'address'
      }
    ],
    'name': 'ERC1967InvalidImplementation',
    'type': 'error'
  },
  {
    'inputs': [],
    'name': 'ERC1967NonPayable',
    'type': 'error'
  },
  {
    'inputs': [
      {
        'internalType': 'address',
        'name': 'spender',
        'type': 'address'
      },
      {
        'internalType': 'uint256',
        'name': 'allowance',
        'type': 'uint256'
      },
      {
        'internalType': 'uint256',
        'name': 'needed',
        'type': 'uint256'
      }
    ],
    'name': 'ERC20InsufficientAllowance',
    'type': 'error'
  },
  {
    'inputs': [
      {
        'internalType': 'address',
        'name': 'sender',
        'type': 'address'
      },
      {
        'internalType': 'uint256',
        'name': 'balance',
        'type': 'uint256'
      },
      {
        'internalType': 'uint256',
        'name': 'needed',
        'type': 'uint256'
      }
    ],
    'name': 'ERC20InsufficientBalance',
    'type': 'error'
  },
  {
    'inputs': [
      {
        'internalType': 'address',
        'name': 'approver',
        'type': 'address'
      }
    ],
    'name': 'ERC20InvalidApprover',
    'type': 'error'
  },
  {
    'inputs': [
      {
        'internalType': 'address',
        'name': 'receiver',
        'type': 'address'
      }
    ],
    'name': 'ERC20InvalidReceiver',
    'type': 'error'
  },
  {
    'inputs': [
      {
        'internalType': 'address',
        'name': 'sender',
        'type': 'address'
      }
    ],
    'name': 'ERC20InvalidSender',
    'type': 'error'
  },
  {
    'inputs': [
      {
        'internalType': 'address',
        'name': 'spender',
        'type': 'address'
      }
    ],
    'name': 'ERC20InvalidSpender',
    'type': 'error'
  },
  {
    'inputs': [
      {
        'internalType': 'address',
        'name': 'receiver',
        'type': 'address'
      },
      {
        'internalType': 'uint256',
        'name': 'assets',
        'type': 'uint256'
      },
      {
        'internalType': 'uint256',
        'name': 'max',
        'type': 'uint256'
      }
    ],
    'name': 'ERC4626ExceededMaxDeposit',
    'type': 'error'
  },
  {
    'inputs': [
      {
        'internalType': 'address',
        'name': 'receiver',
        'type': 'address'
      },
      {
        'internalType': 'uint256',
        'name': 'shares',
        'type': 'uint256'
      },
      {
        'internalType': 'uint256',
        'name': 'max',
        'type': 'uint256'
      }
    ],
    'name': 'ERC4626ExceededMaxMint',
    'type': 'error'
  },
  {
    'inputs': [
      {
        'internalType': 'address',
        'name': 'owner',
        'type': 'address'
      },
      {
        'internalType': 'uint256',
        'name': 'shares',
        'type': 'uint256'
      },
      {
        'internalType': 'uint256',
        'name': 'max',
        'type': 'uint256'
      }
    ],
    'name': 'ERC4626ExceededMaxRedeem',
    'type': 'error'
  },
  {
    'inputs': [
      {
        'internalType': 'address',
        'name': 'owner',
        'type': 'address'
      },
      {
        'internalType': 'uint256',
        'name': 'assets',
        'type': 'uint256'
      },
      {
        'internalType': 'uint256',
        'name': 'max',
        'type': 'uint256'
      }
    ],
    'name': 'ERC4626ExceededMaxWithdraw',
    'type': 'error'
  },
  {
    'inputs': [],
    'name': 'EpochNotPassed',
    'type': 'error'
  },
  {
    'inputs': [],
    'name': 'FailedCall',
    'type': 'error'
  },
  {
    'inputs': [],
    'name': 'InvalidAmount',
    'type': 'error'
  },
  {
    'inputs': [],
    'name': 'InvalidBalance',
    'type': 'error'
  },
  {
    'inputs': [],
    'name': 'InvalidInitialization',
    'type': 'error'
  },
  {
    'inputs': [],
    'name': 'NotFinalized',
    'type': 'error'
  },
  {
    'inputs': [],
    'name': 'NotInitializing',
    'type': 'error'
  },
  {
    'inputs': [],
    'name': 'NotLossManager',
    'type': 'error'
  },
  {
    'inputs': [],
    'name': 'NotVault',
    'type': 'error'
  },
  {
    'inputs': [],
    'name': 'NothingToClaim',
    'type': 'error'
  },
  {
    'inputs': [],
    'name': 'NothingToFinalize',
    'type': 'error'
  },
  {
    'inputs': [],
    'name': 'PauseManagerZeroAddress',
    'type': 'error'
  },
  {
    'inputs': [
      {
        'internalType': 'uint8',
        'name': 'bits',
        'type': 'uint8'
      },
      {
        'internalType': 'uint256',
        'name': 'value',
        'type': 'uint256'
      }
    ],
    'name': 'SafeCastOverflowedUintDowncast',
    'type': 'error'
  },
  {
    'inputs': [
      {
        'internalType': 'address',
        'name': 'token',
        'type': 'address'
      }
    ],
    'name': 'SafeERC20FailedOperation',
    'type': 'error'
  },
  {
    'inputs': [],
    'name': 'SameValue',
    'type': 'error'
  },
  {
    'inputs': [],
    'name': 'UUPSUnauthorizedCallContext',
    'type': 'error'
  },
  {
    'inputs': [
      {
        'internalType': 'bytes32',
        'name': 'slot',
        'type': 'bytes32'
      }
    ],
    'name': 'UUPSUnsupportedProxiableUUID',
    'type': 'error'
  },
  {
    'inputs': [
      {
        'internalType': 'uint256',
        'name': 'requested',
        'type': 'uint256'
      },
      {
        'internalType': 'uint256',
        'name': 'maxAllowed',
        'type': 'uint256'
      }
    ],
    'name': 'UnstakeDelayTooLarge',
    'type': 'error'
  },
  {
    'inputs': [],
    'name': 'UnstakeDelayZero',
    'type': 'error'
  },
  {
    'inputs': [],
    'name': 'YieldStreamIsActive',
    'type': 'error'
  },
  {
    'inputs': [],
    'name': 'ZeroAddress',
    'type': 'error'
  },
  {
    'inputs': [],
    'name': 'ZeroEpochDuration',
    'type': 'error'
  },
  {
    'inputs': [],
    'name': 'ZeroPassedShares',
    'type': 'error'
  },
  {
    'inputs': [],
    'name': 'ZeroYieldPassed',
    'type': 'error'
  },
  {
    'anonymous': false,
    'inputs': [
      {
        'indexed': true,
        'internalType': 'address',
        'name': 'owner',
        'type': 'address'
      },
      {
        'indexed': true,
        'internalType': 'address',
        'name': 'spender',
        'type': 'address'
      },
      {
        'indexed': false,
        'internalType': 'uint256',
        'name': 'value',
        'type': 'uint256'
      }
    ],
    'name': 'Approval',
    'type': 'event'
  },
  {
    'anonymous': false,
    'inputs': [
      {
        'indexed': false,
        'internalType': 'address',
        'name': 'authority',
        'type': 'address'
      }
    ],
    'name': 'AuthorityUpdated',
    'type': 'event'
  },
  {
    'anonymous': false,
    'inputs': [
      {
        'indexed': true,
        'internalType': 'address',
        'name': 'sender',
        'type': 'address'
      },
      {
        'indexed': true,
        'internalType': 'address',
        'name': 'owner',
        'type': 'address'
      },
      {
        'indexed': false,
        'internalType': 'uint256',
        'name': 'assets',
        'type': 'uint256'
      },
      {
        'indexed': false,
        'internalType': 'uint256',
        'name': 'shares',
        'type': 'uint256'
      }
    ],
    'name': 'Deposit',
    'type': 'event'
  },
  {
    'anonymous': false,
    'inputs': [
      {
        'indexed': false,
        'internalType': 'bool',
        'name': 'enabled',
        'type': 'bool'
      },
      {
        'indexed': false,
        'internalType': 'uint256',
        'name': 'cap',
        'type': 'uint256'
      },
      {
        'indexed': false,
        'internalType': 'uint256',
        'name': 'tvlBps',
        'type': 'uint256'
      }
    ],
    'name': 'DepositLimitUpdated',
    'type': 'event'
  },
  {
    'anonymous': false,
    'inputs': [
      {
        'indexed': true,
        'internalType': 'uint256',
        'name': 'epochId',
        'type': 'uint256'
      },
      {
        'indexed': false,
        'internalType': 'uint256',
        'name': 'sharesBurned',
        'type': 'uint256'
      },
      {
        'indexed': false,
        'internalType': 'uint256',
        'name': 'assetsFinal',
        'type': 'uint256'
      }
    ],
    'name': 'EpochFinalized',
    'type': 'event'
  },
  {
    'anonymous': false,
    'inputs': [
      {
        'indexed': false,
        'internalType': 'uint64',
        'name': 'version',
        'type': 'uint64'
      }
    ],
    'name': 'Initialized',
    'type': 'event'
  },
  {
    'anonymous': false,
    'inputs': [
      {
        'indexed': true,
        'internalType': 'address',
        'name': 'newManager',
        'type': 'address'
      }
    ],
    'name': 'PauseManagerUpdated',
    'type': 'event'
  },
  {
    'anonymous': false,
    'inputs': [
      {
        'indexed': true,
        'internalType': 'address',
        'name': 'from',
        'type': 'address'
      },
      {
        'indexed': true,
        'internalType': 'address',
        'name': 'to',
        'type': 'address'
      },
      {
        'indexed': false,
        'internalType': 'uint256',
        'name': 'value',
        'type': 'uint256'
      }
    ],
    'name': 'Transfer',
    'type': 'event'
  },
  {
    'anonymous': false,
    'inputs': [
      {
        'indexed': false,
        'internalType': 'uint256',
        'name': 'newDelayEpochs',
        'type': 'uint256'
      }
    ],
    'name': 'UnstakeDelayUpdated',
    'type': 'event'
  },
  {
    'anonymous': false,
    'inputs': [
      {
        'indexed': true,
        'internalType': 'address',
        'name': 'user',
        'type': 'address'
      },
      {
        'indexed': false,
        'internalType': 'uint256',
        'name': 'shares',
        'type': 'uint256'
      },
      {
        'indexed': false,
        'internalType': 'uint256',
        'name': 'requestEpoch',
        'type': 'uint256'
      },
      {
        'indexed': false,
        'internalType': 'uint256',
        'name': 'targetEpoch',
        'type': 'uint256'
      }
    ],
    'name': 'UnstakeRequested',
    'type': 'event'
  },
  {
    'anonymous': false,
    'inputs': [
      {
        'indexed': false,
        'internalType': 'uint256',
        'name': 'newBps',
        'type': 'uint256'
      }
    ],
    'name': 'UnstakeYieldReductionBpsUpdated',
    'type': 'event'
  },
  {
    'anonymous': false,
    'inputs': [
      {
        'indexed': true,
        'internalType': 'address',
        'name': 'implementation',
        'type': 'address'
      }
    ],
    'name': 'Upgraded',
    'type': 'event'
  },
  {
    'anonymous': false,
    'inputs': [
      {
        'indexed': true,
        'internalType': 'address',
        'name': 'sender',
        'type': 'address'
      },
      {
        'indexed': true,
        'internalType': 'address',
        'name': 'receiver',
        'type': 'address'
      },
      {
        'indexed': true,
        'internalType': 'address',
        'name': 'owner',
        'type': 'address'
      },
      {
        'indexed': false,
        'internalType': 'uint256',
        'name': 'assets',
        'type': 'uint256'
      },
      {
        'indexed': false,
        'internalType': 'uint256',
        'name': 'shares',
        'type': 'uint256'
      }
    ],
    'name': 'Withdraw',
    'type': 'event'
  },
  {
    'anonymous': false,
    'inputs': [
      {
        'indexed': true,
        'internalType': 'address',
        'name': 'user',
        'type': 'address'
      },
      {
        'indexed': true,
        'internalType': 'uint256',
        'name': 'epochId',
        'type': 'uint256'
      },
      {
        'indexed': false,
        'internalType': 'uint256',
        'name': 'assets',
        'type': 'uint256'
      }
    ],
    'name': 'WithdrawalClaimed',
    'type': 'event'
  },
  {
    'anonymous': false,
    'inputs': [
      {
        'indexed': false,
        'internalType': 'uint256',
        'name': 'yieldAmount',
        'type': 'uint256'
      },
      {
        'indexed': false,
        'internalType': 'uint256',
        'name': 'streamStart',
        'type': 'uint256'
      },
      {
        'indexed': false,
        'internalType': 'uint256',
        'name': 'streamEnd',
        'type': 'uint256'
      }
    ],
    'name': 'YieldNotified',
    'type': 'event'
  },
  {
    'inputs': [],
    'name': 'BPS',
    'outputs': [
      {
        'internalType': 'uint256',
        'name': '',
        'type': 'uint256'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [],
    'name': 'MAX_UNSTAKE_DELAY_EPOCHS',
    'outputs': [
      {
        'internalType': 'uint256',
        'name': '',
        'type': 'uint256'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [],
    'name': 'UPGRADE_INTERFACE_VERSION',
    'outputs': [
      {
        'internalType': 'string',
        'name': '',
        'type': 'string'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [
      {
        'internalType': 'address',
        'name': 'owner',
        'type': 'address'
      },
      {
        'internalType': 'address',
        'name': 'spender',
        'type': 'address'
      }
    ],
    'name': 'allowance',
    'outputs': [
      {
        'internalType': 'uint256',
        'name': '',
        'type': 'uint256'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [
      {
        'internalType': 'address',
        'name': 'spender',
        'type': 'address'
      },
      {
        'internalType': 'uint256',
        'name': 'value',
        'type': 'uint256'
      }
    ],
    'name': 'approve',
    'outputs': [
      {
        'internalType': 'bool',
        'name': 'success',
        'type': 'bool'
      }
    ],
    'stateMutability': 'nonpayable',
    'type': 'function'
  },
  {
    'inputs': [],
    'name': 'asset',
    'outputs': [
      {
        'internalType': 'address',
        'name': '',
        'type': 'address'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [],
    'name': 'authority',
    'outputs': [
      {
        'internalType': 'address',
        'name': '',
        'type': 'address'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [
      {
        'internalType': 'address',
        'name': 'account',
        'type': 'address'
      }
    ],
    'name': 'balanceOf',
    'outputs': [
      {
        'internalType': 'uint256',
        'name': '',
        'type': 'uint256'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [
      {
        'internalType': 'uint256',
        'name': 'amount',
        'type': 'uint256'
      }
    ],
    'name': 'burnMZUSD',
    'outputs': [],
    'stateMutability': 'nonpayable',
    'type': 'function'
  },
  {
    'inputs': [
      {
        'internalType': 'address',
        'name': 'user',
        'type': 'address'
      },
      {
        'internalType': 'uint256',
        'name': 'epochId',
        'type': 'uint256'
      }
    ],
    'name': 'claim',
    'outputs': [],
    'stateMutability': 'nonpayable',
    'type': 'function'
  },
  {
    'inputs': [
      {
        'internalType': 'uint256',
        'name': 'shares',
        'type': 'uint256'
      }
    ],
    'name': 'convertToAssets',
    'outputs': [
      {
        'internalType': 'uint256',
        'name': '',
        'type': 'uint256'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [
      {
        'internalType': 'uint256',
        'name': 'assets',
        'type': 'uint256'
      }
    ],
    'name': 'convertToShares',
    'outputs': [
      {
        'internalType': 'uint256',
        'name': '',
        'type': 'uint256'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [],
    'name': 'decimals',
    'outputs': [
      {
        'internalType': 'uint8',
        'name': '',
        'type': 'uint8'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [
      {
        'internalType': 'uint256',
        'name': 'assets',
        'type': 'uint256'
      },
      {
        'internalType': 'address',
        'name': 'receiver',
        'type': 'address'
      }
    ],
    'name': 'deposit',
    'outputs': [
      {
        'internalType': 'uint256',
        'name': '',
        'type': 'uint256'
      }
    ],
    'stateMutability': 'nonpayable',
    'type': 'function'
  },
  {
    'inputs': [],
    'name': 'depositLimitEnabled',
    'outputs': [
      {
        'internalType': 'bool',
        'name': '',
        'type': 'bool'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [],
    'name': 'directWithdrawEnabled',
    'outputs': [
      {
        'internalType': 'bool',
        'name': '',
        'type': 'bool'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [
      {
        'internalType': 'uint256',
        'name': 'epochId',
        'type': 'uint256'
      }
    ],
    'name': 'finalizeEpoch',
    'outputs': [],
    'stateMutability': 'nonpayable',
    'type': 'function'
  },
  {
    'inputs': [
      {
        'internalType': 'uint256',
        'name': '',
        'type': 'uint256'
      }
    ],
    'name': 'finalizedEpochs',
    'outputs': [
      {
        'internalType': 'uint256',
        'name': 'totalShares',
        'type': 'uint256'
      },
      {
        'internalType': 'uint256',
        'name': 'totalAssets',
        'type': 'uint256'
      },
      {
        'internalType': 'uint256',
        'name': 'finalizationPrice',
        'type': 'uint256'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [],
    'name': 'getDepositLimitInfo',
    'outputs': [
      {
        'internalType': 'bool',
        'name': 'enabled',
        'type': 'bool'
      },
      {
        'internalType': 'uint256',
        'name': 'limit',
        'type': 'uint256'
      },
      {
        'internalType': 'uint256',
        'name': 'limitByTvl',
        'type': 'uint256'
      },
      {
        'internalType': 'uint256',
        'name': 'cap',
        'type': 'uint256'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [
      {
        'internalType': 'uint256',
        'name': 'epochId',
        'type': 'uint256'
      }
    ],
    'name': 'getEpochInfo',
    'outputs': [
      {
        'internalType': 'uint256',
        'name': 'umbrellaShares',
        'type': 'uint256'
      },
      {
        'internalType': 'bool',
        'name': 'isFinalized',
        'type': 'bool'
      },
      {
        'internalType': 'uint256',
        'name': 'totalShares',
        'type': 'uint256'
      },
      {
        'internalType': 'uint256',
        'name': 'totalAssets_',
        'type': 'uint256'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [
      {
        'internalType': 'address',
        'name': 'user',
        'type': 'address'
      },
      {
        'internalType': 'uint256',
        'name': 'epochId',
        'type': 'uint256'
      }
    ],
    'name': 'getUserEpochInfo',
    'outputs': [
      {
        'internalType': 'uint256',
        'name': 'pendingShares',
        'type': 'uint256'
      },
      {
        'internalType': 'uint256',
        'name': 'claimableAssets',
        'type': 'uint256'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [
      {
        'internalType': 'uint256',
        'name': 'trancheIdentifier',
        'type': 'uint256'
      },
      {
        'internalType': 'uint256',
        'name': 'initialUnstakeDelayEpochs',
        'type': 'uint256'
      },
      {
        'internalType': 'string',
        'name': 'name_',
        'type': 'string'
      },
      {
        'internalType': 'string',
        'name': 'symbol_',
        'type': 'string'
      }
    ],
    'name': 'initialize',
    'outputs': [],
    'stateMutability': 'nonpayable',
    'type': 'function'
  },
  {
    'inputs': [],
    'name': 'isConsumingScheduledOp',
    'outputs': [
      {
        'internalType': 'bytes4',
        'name': '',
        'type': 'bytes4'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [
      {
        'internalType': 'address',
        'name': '',
        'type': 'address'
      }
    ],
    'name': 'maxDeposit',
    'outputs': [
      {
        'internalType': 'uint256',
        'name': '',
        'type': 'uint256'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [],
    'name': 'maxDepositCap',
    'outputs': [
      {
        'internalType': 'uint256',
        'name': '',
        'type': 'uint256'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [],
    'name': 'maxDepositTvlBps',
    'outputs': [
      {
        'internalType': 'uint256',
        'name': '',
        'type': 'uint256'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [
      {
        'internalType': 'address',
        'name': '',
        'type': 'address'
      }
    ],
    'name': 'maxMint',
    'outputs': [
      {
        'internalType': 'uint256',
        'name': '',
        'type': 'uint256'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [
      {
        'internalType': 'address',
        'name': 'owner',
        'type': 'address'
      }
    ],
    'name': 'maxRedeem',
    'outputs': [
      {
        'internalType': 'uint256',
        'name': '',
        'type': 'uint256'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [
      {
        'internalType': 'address',
        'name': 'owner',
        'type': 'address'
      }
    ],
    'name': 'maxWithdraw',
    'outputs': [
      {
        'internalType': 'uint256',
        'name': '',
        'type': 'uint256'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [
      {
        'internalType': 'uint256',
        'name': 'shares',
        'type': 'uint256'
      },
      {
        'internalType': 'address',
        'name': 'receiver',
        'type': 'address'
      }
    ],
    'name': 'mint',
    'outputs': [
      {
        'internalType': 'uint256',
        'name': '',
        'type': 'uint256'
      }
    ],
    'stateMutability': 'nonpayable',
    'type': 'function'
  },
  {
    'inputs': [],
    'name': 'name',
    'outputs': [
      {
        'internalType': 'string',
        'name': '',
        'type': 'string'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [
      {
        'internalType': 'uint256',
        'name': 'yieldAmount',
        'type': 'uint256'
      }
    ],
    'name': 'notifyYield',
    'outputs': [],
    'stateMutability': 'nonpayable',
    'type': 'function'
  },
  {
    'inputs': [],
    'name': 'pauseManager',
    'outputs': [
      {
        'internalType': 'address',
        'name': '',
        'type': 'address'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [
      {
        'internalType': 'uint256',
        'name': 'assets',
        'type': 'uint256'
      }
    ],
    'name': 'previewDeposit',
    'outputs': [
      {
        'internalType': 'uint256',
        'name': '',
        'type': 'uint256'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [
      {
        'internalType': 'uint256',
        'name': 'shares',
        'type': 'uint256'
      }
    ],
    'name': 'previewMint',
    'outputs': [
      {
        'internalType': 'uint256',
        'name': '',
        'type': 'uint256'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [
      {
        'internalType': 'uint256',
        'name': 'shares',
        'type': 'uint256'
      }
    ],
    'name': 'previewRedeem',
    'outputs': [
      {
        'internalType': 'uint256',
        'name': '',
        'type': 'uint256'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [
      {
        'internalType': 'uint256',
        'name': 'assets',
        'type': 'uint256'
      }
    ],
    'name': 'previewWithdraw',
    'outputs': [
      {
        'internalType': 'uint256',
        'name': '',
        'type': 'uint256'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [],
    'name': 'pricePerShare',
    'outputs': [
      {
        'internalType': 'uint256',
        'name': 'pricePerShare_',
        'type': 'uint256'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [],
    'name': 'proxiableUUID',
    'outputs': [
      {
        'internalType': 'bytes32',
        'name': '',
        'type': 'bytes32'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [
      {
        'internalType': 'uint256',
        'name': 'shares',
        'type': 'uint256'
      },
      {
        'internalType': 'address',
        'name': 'receiver',
        'type': 'address'
      },
      {
        'internalType': 'address',
        'name': 'owner',
        'type': 'address'
      }
    ],
    'name': 'redeem',
    'outputs': [
      {
        'internalType': 'uint256',
        'name': '',
        'type': 'uint256'
      }
    ],
    'stateMutability': 'nonpayable',
    'type': 'function'
  },
  {
    'inputs': [
      {
        'internalType': 'uint256',
        'name': 'shares',
        'type': 'uint256'
      }
    ],
    'name': 'requestWithdrawal',
    'outputs': [],
    'stateMutability': 'nonpayable',
    'type': 'function'
  },
  {
    'inputs': [],
    'name': 'reservedAssets',
    'outputs': [
      {
        'internalType': 'uint256',
        'name': '',
        'type': 'uint256'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [
      {
        'internalType': 'address',
        'name': 'newAuthority',
        'type': 'address'
      }
    ],
    'name': 'setAuthority',
    'outputs': [],
    'stateMutability': 'nonpayable',
    'type': 'function'
  },
  {
    'inputs': [
      {
        'internalType': 'bool',
        'name': 'enabled',
        'type': 'bool'
      }
    ],
    'name': 'setDepositLimitEnabled',
    'outputs': [],
    'stateMutability': 'nonpayable',
    'type': 'function'
  },
  {
    'inputs': [
      {
        'internalType': 'uint256',
        'name': 'cap',
        'type': 'uint256'
      },
      {
        'internalType': 'uint256',
        'name': 'tvlBps',
        'type': 'uint256'
      }
    ],
    'name': 'setDepositLimits',
    'outputs': [],
    'stateMutability': 'nonpayable',
    'type': 'function'
  },
  {
    'inputs': [
      {
        'internalType': 'uint256',
        'name': 'epochsDelay',
        'type': 'uint256'
      }
    ],
    'name': 'setUnstakeDelayEpochs',
    'outputs': [],
    'stateMutability': 'nonpayable',
    'type': 'function'
  },
  {
    'inputs': [
      {
        'internalType': 'uint256',
        'name': 'bps',
        'type': 'uint256'
      }
    ],
    'name': 'setUnstakeYieldReductionBps',
    'outputs': [],
    'stateMutability': 'nonpayable',
    'type': 'function'
  },
  {
    'inputs': [],
    'name': 'symbol',
    'outputs': [
      {
        'internalType': 'string',
        'name': '',
        'type': 'string'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [],
    'name': 'totalAssets',
    'outputs': [
      {
        'internalType': 'uint256',
        'name': 'totalAssets_',
        'type': 'uint256'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [],
    'name': 'totalSupply',
    'outputs': [
      {
        'internalType': 'uint256',
        'name': '',
        'type': 'uint256'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [],
    'name': 'trancheId',
    'outputs': [
      {
        'internalType': 'uint256',
        'name': '',
        'type': 'uint256'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [
      {
        'internalType': 'address',
        'name': 'to',
        'type': 'address'
      },
      {
        'internalType': 'uint256',
        'name': 'value',
        'type': 'uint256'
      }
    ],
    'name': 'transfer',
    'outputs': [
      {
        'internalType': 'bool',
        'name': 'success',
        'type': 'bool'
      }
    ],
    'stateMutability': 'nonpayable',
    'type': 'function'
  },
  {
    'inputs': [
      {
        'internalType': 'address',
        'name': 'from',
        'type': 'address'
      },
      {
        'internalType': 'address',
        'name': 'to',
        'type': 'address'
      },
      {
        'internalType': 'uint256',
        'name': 'value',
        'type': 'uint256'
      }
    ],
    'name': 'transferFrom',
    'outputs': [
      {
        'internalType': 'bool',
        'name': 'success',
        'type': 'bool'
      }
    ],
    'stateMutability': 'nonpayable',
    'type': 'function'
  },
  {
    'inputs': [
      {
        'internalType': 'uint256',
        'name': '',
        'type': 'uint256'
      }
    ],
    'name': 'umbrellaSharesByEpoch',
    'outputs': [
      {
        'internalType': 'uint256',
        'name': '',
        'type': 'uint256'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [],
    'name': 'unaccruedYield',
    'outputs': [
      {
        'internalType': 'uint256',
        'name': 'unaccrued',
        'type': 'uint256'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [],
    'name': 'unstakeDelayEpochs',
    'outputs': [
      {
        'internalType': 'uint256',
        'name': '',
        'type': 'uint256'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [],
    'name': 'unstakeYieldReductionBps',
    'outputs': [
      {
        'internalType': 'uint256',
        'name': '',
        'type': 'uint256'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [
      {
        'internalType': 'address',
        'name': 'newImplementation',
        'type': 'address'
      },
      {
        'internalType': 'bytes',
        'name': 'data',
        'type': 'bytes'
      }
    ],
    'name': 'upgradeToAndCall',
    'outputs': [],
    'stateMutability': 'payable',
    'type': 'function'
  },
  {
    'inputs': [
      {
        'internalType': 'address',
        'name': '',
        'type': 'address'
      },
      {
        'internalType': 'uint256',
        'name': '',
        'type': 'uint256'
      }
    ],
    'name': 'userSharesByEpoch',
    'outputs': [
      {
        'internalType': 'uint256',
        'name': '',
        'type': 'uint256'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [
      {
        'internalType': 'address',
        'name': '',
        'type': 'address'
      },
      {
        'internalType': 'uint256',
        'name': '',
        'type': 'uint256'
      }
    ],
    'name': 'userSnapshotPrice',
    'outputs': [
      {
        'internalType': 'uint256',
        'name': '',
        'type': 'uint256'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [],
    'name': 'vault',
    'outputs': [
      {
        'internalType': 'address',
        'name': '',
        'type': 'address'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [
      {
        'internalType': 'uint256',
        'name': 'assets',
        'type': 'uint256'
      },
      {
        'internalType': 'address',
        'name': 'receiver',
        'type': 'address'
      },
      {
        'internalType': 'address',
        'name': 'owner',
        'type': 'address'
      }
    ],
    'name': 'withdraw',
    'outputs': [
      {
        'internalType': 'uint256',
        'name': '',
        'type': 'uint256'
      }
    ],
    'stateMutability': 'nonpayable',
    'type': 'function'
  },
  {
    'inputs': [],
    'name': 'yieldStreamEnd',
    'outputs': [
      {
        'internalType': 'uint48',
        'name': '',
        'type': 'uint48'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [],
    'name': 'yieldStreamStart',
    'outputs': [
      {
        'internalType': 'uint48',
        'name': '',
        'type': 'uint48'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  },
  {
    'inputs': [],
    'name': 'yieldStreamingAmount',
    'outputs': [
      {
        'internalType': 'uint256',
        'name': '',
        'type': 'uint256'
      }
    ],
    'stateMutability': 'view',
    'type': 'function'
  }
] as const;
